import { IconButton } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { useNavigate } from 'react-router-dom'

export default function BackNavButton() {
  const navigate = useNavigate()
  return (
    <IconButton onClick={() => navigate(-1)}>
      <ArrowBackIosNewIcon />
    </IconButton>
  )
}
